import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import type { AdminUserTab, UserRole } from '@/entities/admin-user.entity';

const BASE_TABS: { id: AdminUserTab; label: string }[] = [
	{ id: 'clients', label: 'Клиенты' },
	{ id: 'builds', label: 'Билды' },
	{ id: 'profits', label: 'Профиты' },
	{ id: 'landings', label: 'Лендинги' },
	{ id: 'sender', label: 'Sender' },
	{ id: 'manage', label: 'Управление' },
];

interface UserTabsProps {
	activeTab: AdminUserTab;
	onTabChange: (tab: AdminUserTab) => void;
	userRole?: UserRole;
}

export default function UserTabs({ activeTab, onTabChange }: UserTabsProps) {
	const tabs = BASE_TABS;

	return (
		<div className='flex gap-1.5 overflow-x-auto pb-1'>
			<ButtonGroup className='shrink-0'>
				{tabs.map(tab => (
					<Button
						key={tab.id}
						size='sm'
						variant={activeTab === tab.id ? 'secondary' : 'outline'}
						onClick={() => onTabChange(tab.id)}
					>
						{tab.label}
					</Button>
				))}
			</ButtonGroup>
		</div>
	);
}
